export const universityProgramMap = {
    "Amity University": [
        "Online MBA",
        "Online MBA in Hospital & Healthcare Management"
    ],
    "Amrita Vishwa Vidyapeetham": [
        "MBA(AI)",
        "MBA(General Management)",
        "MBA(Marketing/HR/Finance/Operations)",
        "MBA (Environmental, Social, and Governance)",
        "MBA (Business Analytics)"
    ],
    "Bharati Vidyapeeth": ["MBA"],
    "Chandigarh University": ["MBA"],
    "D Y Patil Vidyapeeth": [
        "Online MBA",
        "MBA (Wx)"
    ],
    "Dayananda Sagar University": ["Executive MBA"],
    "Dr. M.G.R. University": ["MBA"],
    "LIBA": ["Online PGDM"],
    "Manipal University, Jaipur": ["Online MBA Programme"],
    "Parul University": ["MBA"],
    "Sikkim Manipal University": ["MBA"],
    "Symbiosis School For Online And Digital Learning": ["Online MBA Degree Programme"],
    "Any": ["Online MBA", "Online MBA Programme"]
};
